import apiClient from './client';

export const subscriptionAPI = {
  getPlans: () => apiClient.get('/subscriptions/plans'),
  getMySubscription: (businessId) => apiClient.get('/subscriptions/my-plan', { params: { business_id: businessId } }),
  subscribe: (data) => apiClient.post('/subscriptions/subscribe', data),
  cancel: (businessId, reason) => apiClient.post('/subscriptions/cancel', { business_id: businessId, reason }),
  resume: (businessId) => apiClient.post('/subscriptions/resume', { business_id: businessId }),
  checkLimit: (businessId, limitType) => apiClient.get('/subscriptions/check-limit', { params: { business_id: businessId, limit_type: limitType } }),
  getUsage: (businessId) => apiClient.get('/subscriptions/usage', { params: { business_id: businessId } }),
};